module.exports = __webpack_public_path__ + "img/analysis_narrowscreen.eaa6ed77.svg";